import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "search-appliance-icon-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchApplianceIconItem = _resolveComponent("SearchApplianceIconItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.appliances, (item) => {
      return (_openBlock(), _createBlock(_component_SearchApplianceIconItem, {
        class: "search-appliance-icon-list-item",
        key: item.id,
        eoj: item.product.eoj
      }, null, 8, ["eoj"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}